import { useState } from 'react';
import { Link } from 'react-router';
import { authService } from '../lib/api-service';

interface TermsAcceptanceModalProps {
  onAccepted: () => void;
}

export function TermsAcceptanceModal({ onAccepted }: TermsAcceptanceModalProps) {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [marketingAccepted, setMarketingAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit() {
    if (!termsAccepted) return;
    setSubmitting(true);
    setError('');
    try {
      await authService.acceptTerms(marketingAccepted);
      onAccepted();
    } catch {
      setError('A apărut o eroare. Încearcă din nou.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/50 p-4">
      <div
        className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl"
        style={{ fontFamily: 'var(--font-secondary)' }}
      >
        <h2
          className="mb-2 text-xl font-bold"
          style={{ color: 'var(--vivid-purple)', fontFamily: 'var(--font-primary)' }}
        >
          Bine ai venit!
        </h2>
        <p className="mb-5 text-sm text-muted-foreground">
          Pentru a continua, te rugăm să accepți politica de confidențialitate și termenii și condițiile platformei.
        </p>

        {error && (
          <div className="mb-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{error}</div>
        )}

        <div className="space-y-3">
          <label className="flex items-start gap-3 text-sm">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
              className="mt-0.5 h-4 w-4 shrink-0 rounded accent-[var(--vivid-purple)]"
            />
            <span>
              Am citit și sunt de acord cu{' '}
              <Link to="/confidentialitate" target="_blank" className="text-[var(--vivid-purple)] underline">
                Politica de Confidențialitate
              </Link>{' '}
              și{' '}
              <Link to="/termeni" target="_blank" className="text-[var(--vivid-purple)] underline">
                Termenii și Condițiile
              </Link>
              . <span className="text-red-500">*</span>
            </span>
          </label>

          <label className="flex items-start gap-3 text-sm">
            <input
              type="checkbox"
              checked={marketingAccepted}
              onChange={(e) => setMarketingAccepted(e.target.checked)}
              className="mt-0.5 h-4 w-4 shrink-0 rounded accent-[var(--vivid-purple)]"
            />
            <span>
              Sunt de acord să primesc notificări și comunicări prin email despre activități și evenimente. (opțional)
            </span>
          </label>
        </div>

        <button
          onClick={handleSubmit}
          disabled={!termsAccepted || submitting}
          className="mt-6 w-full rounded-lg bg-[var(--vivid-purple)] py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--vivid-purple)]/90 disabled:opacity-50"
          style={{ fontFamily: 'var(--font-primary)' }}
        >
          {submitting ? 'Se salvează...' : 'Continuă'}
        </button>
      </div>
    </div>
  );
}
